module.exports = __webpack_public_path__ + "static/media/grandmom2.2baa234e.svg";